<template>
  <div v-if="JobStatus > 49">
    <router-btn :text="$t('servicesystem.common_objects.commonterms.approve')" :icon="approveStatsIcon"
      :color="isApproveable ? 'quaternary' : 'disabled'" :disabled="false" :outlined="false" :textbtn="textbtn"
      :info="$t('servicesystem.common_objects.commonterms.approve')"
      :large="large" :small="small" @Press="isApproveable ? action() : null">
    </router-btn>
    <ApproveJobDialog :externaltrigger="dialogtrigger" />
  </div>
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import ApproveJobDialog from "@/components/Dialogs/ApproveJobDialog.vue";

export default {
  name: "ApproveJobBtn",
  props: ["large", "small", "textbtn"],
  components: {
    RouterBtn,
    ApproveJobDialog,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
    };
  },

  created() { },

  mounted() { },

  methods: {
    action2() {
      this.dialogtrigger++;
    },
    async action() {
      var config = {
        title: this.$t("servicesystem.common_objects.job.approve_job_confirm_title"),
        message: this.$t("servicesystem.common_objects.job.approve_job_confirm_body"),
        dontRemindMeKey: 'JobApprovalDontShowConfirmation',
      };
      var result = await this.$store.dispatch("ConfirmDialog/Show", config);
      if (result) {
        this.loading = true;
        this.approveJob(this.$route.params.jobId)
          .then(() => {
            this.$router.push({ query: { timestamp: this.getNowTime(this.oldTimeFormat) } });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },

  computed: {
    approveStatsIcon() {
      return this.statusicon(70);
    },

    isApproveable() {
      return this.$store.getters["JobHub/IsApproveable"];
    },
    JobStatus() {
      return this.$store.getters["JobHub/JobStatus"];
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
